export const topics = [
  {
    id: "autumn-2025",
    title: "2025秋季新番特辑",
    description: "一网打尽本季所有值得追的新番，从预告到口碑全解析。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20themed%20banner%20illustration%20of%20a%20stack%20of%20colorful%20autumn%20anime%20posters%20with%20warm%20orange%20falling%20leaves%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20festive%20energetic%20atmosphere%2C%20clean%20editorial%20composition%2C%20high%20quality%20magazine%20cover%20style&width=1200&height=700&seq=wolf-topic-01&orientation=landscape",
    count: 30,
  },
  {
    id: "classic-ten",
    title: "经典动漫回顾：十年十佳",
    description: "回顾过去十年间最值得一看的十部动画，重温那些经典瞬间。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20themed%20banner%20illustration%20of%20a%20nostalgic%20film%20reel%20with%20classic%20anime%20silhouettes%20and%20golden%20light%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20warm%20retro%20atmosphere%2C%20clean%20editorial%20composition%2C%20high%20quality%20magazine%20cover%20style&width=1200&height=700&seq=wolf-topic-02&orientation=landscape",
    count: 10,
  },
  {
    id: "guoman-rise",
    title: "国产动画崛起之路",
    description: "聚焦国产动画的高光时刻，看国漫如何一步步走向世界。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20donghua%20themed%20banner%20illustration%20of%20a%20majestic%20chinese%20dragon%20among%20ink%20clouds%20and%20mountains%2C%20vibrant%20cel-shaded%20art%20style%2C%20epic%20red%20and%20gold%20atmosphere%2C%20clean%20editorial%20composition%2C%20high%20quality%20magazine%20cover%20style&width=1200&height=700&seq=wolf-topic-03&orientation=landscape",
    count: 18,
  },
  {
    id: "healing-list",
    title: "治愈系动漫合集",
    description: "累了就来看看这些温暖的作品，让心情被好好治愈一次。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20themed%20banner%20illustration%20of%20a%20cozy%20sunlit%20cafe%20with%20soft%20pastel%20colors%20and%20plants%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20warm%20gentle%20healing%20atmosphere%2C%20clean%20editorial%20composition%2C%20high%20quality%20magazine%20cover%20style&width=1200&height=700&seq=wolf-topic-04&orientation=landscape",
    count: 15,
  },
];